import PropTypes from 'prop-types';
import React from 'react';
import _ from "lodash";

import { translate as t } from '../../lib/I18n';

import PureRenderComponent from '../PureRenderComponent';
import Icon from '../general/Icon';
import HelpModal from '../general/HelpModal';

class HelpIcon extends PureRenderComponent {

    static propTypes = {
        body: PropTypes.element,
        buttonClassName: PropTypes.string,
        centerMessage: PropTypes.bool,
        className: PropTypes.string,
        heading: PropTypes.string,
        icon: PropTypes.string,
        message: PropTypes.string,
        modalClassName: PropTypes.string,
        moreInfoText: PropTypes.element,
        onClick: PropTypes.func,
        onOpen: PropTypes.func,
    };

    static defaultProps = {
        buttonClassName: '',
        centerMessage: false,
        className: '',
        heading: 'info.title',
        icon: 'info',
        onClick: null,
        onOpen: _.noop,
        modalClassName: 'modal--sm',
    };

    state = {
        showModal: false
    }

    toggleInfoModal = (e) => {
        this.setState({ showModal: !this.state.showModal });
        if (e && e.preventDefault) {
            e.preventDefault();
        }
    }

    render () {
        return (
            <React.Fragment>
                <button
                    type="button"
                    className={ `btn help-icon otrl-inline btn-plain ${this.props.buttonClassName}` }
                    title={ t(this.props.heading) }
                    onClick={ this.props.onClick || this.toggleInfoModal }
                    aria-label={ t(this.props.heading) }
                    role="link"
                    tabIndex="0"
                >
                    <Icon
                        className={ this.props.className }
                        icon={ this.props.icon }
                    />
                </button>

                <HelpModal
                    show={ this.state.showModal }
                    onClose={ this.toggleInfoModal }
                    onOpen={ this.props.onOpen }
                    icon={ this.props.icon }
                    heading={ t(this.props.heading) }
                    message={ this.props.message }
                    centerMessage={ this.props.centerMessage }
                    className={ this.props.modalClassName }
                    moreInfoText={ this.props.moreInfoText }
                >
                    { this.props.body }
                </HelpModal>
            </React.Fragment>
        );
    }
}

export default HelpIcon;



// WEBPACK FOOTER //
// ./src/components/general/HelpIcon.js